"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.broadcastRoles = broadcastRoles;
var _types = require("../../actions/broadcastRoles/types");
var initialState = [];
function broadcastRoles() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.GET_BROADCAST_ROLES_WITH_USERS, "_SUCCESS")) {
    return action.payload.data;
  }
  return state;
}